import { render, staticRenderFns } from "./MotorQuickInfo.vue?vue&type=template&id=6a193dfc&"
import script from "./MotorQuickInfo.vue?vue&type=script&lang=js&"
export * from "./MotorQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./MotorQuickInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorQuickInfo.vue"
export default component.exports